<template>
    <v-container class="pa-2" fluid grid-list-sm >   
        <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>

        <v-row v-if="content">
            <v-col cols=9 class="course-content"> 
                <v-card class="background-transparent shadow-none">
                    <v-row class="course-primary-title">
                        <v-col cols = 6>
                            <h2 >
                                <span>{{content.course.name}}</span>
                            </h2>
                        </v-col>    
                        <v-col cols = 6 class="course-additional-activities background-transparent shadow-none">
                            <v-btn small class="background-transparent" @click="content_type = 0" v-if="content.chapters_count> 0">Chapters</v-btn>
                            <v-btn small class="background-transparent" @click="showStudentRevisions()">Revisions</v-btn> <!-- v-if="content.exercises_count> 1 " -->
                            <v-btn small class="background-transparent" @click="showCompetitions()" v-if="content.competitions_count>0">Competitions</v-btn>
                            <v-btn small class="background-transparent" @click="showStudentDuels()">Duels</v-btn>
                            <v-btn small class="background-transparent" @click="showStudentQuizzes()">Quizzes</v-btn>
                        </v-col>
                    </v-row>
                <v-card-text v-if="content_type == 0">
                    <div class="all-course-topics">
                        <v-layout row wrap justify-center>              
                            
                            <v-flex v-for="(chapter, index) in content.chapter_list" v-bind:key="chapter.chapter_id" shrink xs3 @click = "goToChapter(chapter)">
                                <div class="course-topic">
                                     <div class="course-topic-box" :style="getCourseBackgroundColor(area_color)">
                                        <inline-svg  v-if="chapter.chapter_icon != null & chapter.chapter_icon != ''"
                                            :src="chapter.chapter_icon" 
                                            class="topic-icon"
                                        ></inline-svg>

                                        <div class="topic-progress-info">
                                            <div class="topic-progress-info__item">
                                                <v-icon>contact_support</v-icon>
                                                <v-progress-linear
                                                    :width="10 * (describer[index].tasks_exists)"
                                                    :height="23"
                                                    :value="describer[index].progress_tasks"
                                                    :color="getProgressColor(describer[index].progress_tasks)" class="linear-progress task-linear-progressbar">
                                                    <b><span style="color:darkolivegreen"> {{chapter.tasks_finished}} / {{chapter.tasks_finished+chapter.tasks_nonfinished}}</span></b>
                                                </v-progress-linear>
                                            </div>

                                            <div class="topic-progress-info__item">
                                                <v-icon>code</v-icon>
                                                <v-progress-linear
                                                    :width="10 * (describer[index].programs_exists)"
                                                    :height="23"
                                                    :value="describer[index].progress_programs"
                                                    :color="getProgressColor(describer[index].progress_programs)" class="linear-progress program-linear-progressbar">
                                                    <b><span style="color:darkolivegreen">{{chapter.programs_finished}} / {{chapter.programs_finished + chapter.programs_nonfinished}}</span></b>
                                                </v-progress-linear>
                                                
                                            </div>
                                            

                                            
                                        </div>

                                        <v-icon v-if="!describer[index].active" class="access-icon" color="red">block</v-icon>                                    
                                        <v-icon v-if="describer[index].active" class="access-icon" color="green">forward</v-icon>  
                                     </div>
                                    <h2 class="topic-title">{{chapter.chapter_name}}</h2>
                                </div>
                            </v-flex>

                        </v-layout>
                    </div>
                </v-card-text>
                <v-card-text v-if="content_type == 1">

                </v-card-text>
                <v-card-text v-if="content_type == 2 && dataCompetition">
                    <v-card outlined class="competitions-tab">
                        <v-card-title class="competitions-tab-heading">Active competitions</v-card-title>
                        <div class="competitions-tab-content">
                            <v-card-text class="competitions-tab-head">
                                <v-row>
                                    <v-flex xs1></v-flex>
                                    <v-flex xs3><strong>Name</strong></v-flex>
                                    <v-flex xs2><strong>Start</strong></v-flex>
                                    <v-flex xs2><strong>End</strong></v-flex>                                
                                    <v-flex xs1><strong>Time limit (s)</strong></v-flex>                        
                                    <v-flex xs1></v-flex>

                                </v-row>
                            </v-card-text>
                            <v-card-text v-for="(competition, index) in dataCompetition.opened" :key="index" class="competitions-tab-body">
                                <v-row>
                                    <v-flex xs1><v-img :src="competition.icon" width="40px" height="40px" class="competition-icon-img" alt=""></v-img></v-flex>
                                    <v-flex xs3>{{competition.name}}</v-flex>
                                    <v-flex xs2><span v-if="competition.check_OB">{{competition.open_begin}}</span></v-flex>
                                    <v-flex xs2><span v-if="competition.check_OE">{{competition.open_end}}</span></v-flex>
                                    <v-flex xs1>{{competition.time_limit}}</v-flex>                        
                                    <v-flex xs1><v-icon @click="startCompetition(index)" color="green">login </v-icon></v-flex>
                                </v-row>   
                            </v-card-text>
                        </div>
                    </v-card>
                    <v-card outlined class="competitions-tab">
                        <v-card-title class="competitions-tab-heading">My competitions</v-card-title>
                        <div class="competitions-tab-content">
                            <v-card-text class="competitions-tab-head">
                                <v-row>
                                    <v-flex xs1></v-flex>
                                    <v-flex xs3><strong>Name</strong></v-flex>
                                    <v-flex xs2><strong>Start</strong></v-flex>
                                    <v-flex xs2><strong>End</strong></v-flex>                                
                                    <v-flex xs1><strong>Timelimit (s)</strong></v-flex>                        
                                    <v-flex xs1><strong>Status</strong></v-flex>                        
                                    <v-flex xs1><strong>Score</strong></v-flex>
                                    <v-flex xs1><strong>Description</strong></v-flex>

                                </v-row>
                            </v-card-text>
                            <v-card-text style="cursor:pointer" @click="openCompetition(index)" v-for="(competition, index) in dataCompetition.joined" :key="index" class="competitions-tab-body">
                                <v-row>
                                    <v-flex xs1><v-img :src="competition.icon" width="40px" height="40px" class="competition-icon-img" alt=""></v-img></v-flex>
                                    <v-flex xs3 >{{competition.name}}</v-flex>
                                    <v-flex xs2><span>{{competition.begin_at}}</span></v-flex>
                                    <v-flex xs2><span>{{competition.end_at}}</span></v-flex>
                                    <v-flex xs1>{{competition.time_limit}}</v-flex>                        
                                    <v-flex xs1>{{competition.status}}</v-flex>                        
                                    <v-flex xs1>{{competition.score}}</v-flex>
                                    <v-flex xs2>{{competition.description}}</v-flex>
                                </v-row>   
                            </v-card-text>
                        </div>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-col>
         <v-col class="course-sidebar" cols=3>
            <v-card v-if="dataCourse" class="course-info-card card-border-style border-radius-lg shadow-none">
                <v-card-title class="card-title">
                    Course content
                    <v-icon large class="material-icons-outlined btn-close" title = "My course settings" style="cursor:pointer" @click="studentSettings()">settings</v-icon>
                </v-card-title>
                <v-card-text>
                        <v-layout class="row-task-type-summary">
                            <v-flex xs5>
                                <div>
                                <v-icon :color="area_color" class="material-icons-outlined" >description</v-icon>                                
                                <v-progress-linear
                                        :value="progress.content"
                                        :color="area_color"
                                        height="25"
                                    />
                                <span>{{progress.content}} %</span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <div><b>
                                    {{content.detail_score[0].content_passed}}/{{content.detail_score[0].content_count}}
                                </b></div>
                            </v-flex>
                        </v-layout>
                        <v-layout class="row-task-type-summary" row>
                            <v-flex xs5>
                                <div>
                                    <v-icon :color="area_color" class="material-icons-outlined" >contact_support</v-icon>
                                    <v-progress-linear
                                            :value="progress.tasks"
                                            :color="area_color"
                                            height="25"
                                        />  
                                    <span>{{progress.tasks}} %</span>
                                </div>
                            </v-flex>
                            <v-flex xs3>
                                <div><b>
                                    {{content.detail_score[0].task_passed}}/{{content.detail_score[0].task_count}}
                                </b></div>
                            </v-flex>
                            <v-flex xs1>
                                <img class="course-info-icon" src="@/assets/img/icons/XP.svg" alt="xp">    
                            </v-flex>
                            <v-flex xs3>
                                <div><b>
                                    {{content.detail_score[0].score_task}}/{{content.detail_score[0].max_score_task}}
                                </b></div>
                            </v-flex>
                        </v-layout>
                        <v-layout class="row-task-type-summary" row>
                            <v-flex xs5>
                                <div>
                                    <v-icon :color="area_color" class="material-icons-outlined">code</v-icon>
                                    <v-progress-linear
                                            :value="progress.programs"
                                            :color="area_color"
                                            height="25"
                                        /> 
                                    <span>{{progress.programs}} %</span>
                                </div>
                            </v-flex>
                            <v-flex xs3>
                                <div><b>
                                    {{content.detail_score[0].program_passed}}/{{content.detail_score[0].program_count}}
                                </b></div>
                            </v-flex>
                            <v-flex xs1>
                                <img class="course-info-icon" src="@/assets/img/icons/XP.svg" alt="xp">    
                            </v-flex>
                            <v-flex xs3>
                                <div><b>
                                    {{content.detail_score[0].score_program}}/{{content.detail_score[0].max_score_program}}
                                </b></div>
                            </v-flex>
                        </v-layout>
                </v-card-text>
            </v-card>
            <v-card v-if="editPermissions.edit" class="course-info-card card-border-style border-radius-lg shadow-none">
                <!-- <class="course-info-card card-border-style border-radius-lg shadow-none"> -->
                <v-card-title class="card-title">
                    Admin dashboard
                </v-card-title>
                <v-card-text>
                    <v-card class="course-additional-activities background-transparent shadow-none">
                        <v-btn class="background-transparent" @click="editCourse()">Edit content</v-btn>
                        <v-btn class="background-transparent" @click="showCourseTeachers()">Teachers</v-btn>
                    </v-card>
                </v-card-text>
            </v-card>
            <v-card v-if="teacherPermissions" class="course-info-card card-border-style border-radius-lg shadow-none">
                <v-card-title class="card-title">
                    Teacher dashboard
                </v-card-title>
                <v-card-text>
                    <v-card class="course-additional-activities background-transparent shadow-none">
                        <v-btn class="background-transparent" @click="showChapters()">Chapters</v-btn>
                        <v-btn class="background-transparent" @click="showTeacherRevisions()">Revisions</v-btn>
                        <v-btn class="background-transparent" @click="showQuizzes()">Quizzes</v-btn>
                        <v-btn class="background-transparent" @click="editGroups()">Groups</v-btn>
                        <v-btn class="background-transparent" @click="teacherCompetitions()">Competitions</v-btn>                        
                    </v-card>
                </v-card-text>
            </v-card>  
        </v-col> 
        </v-row>
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                    'getShowModalMessageResult'                    
                ]),
    data() {
        return {
            progress : {
                content : 0,
                tasks: 0,
                programs: 0
            },
            content : null,
            populate: -1,
            chapterIndex: -1,
            lessonRead: false,
            describer: [],
            area_id: null,
            area_color: "#000000",
            dataCourse : null,
            dataCompetition: null,
            showMore : false,
            showText: 'Show more    ',
            content_type: 0,
            competition_index : -1,
            editPermissions : {edit:false},
            teacherPermissions: false
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    

            // get category list
            axios.get('/get-active-chapters2/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    /* eslint-disable no-console */
                    // console.log(res.data)
                    this.content = res.data 
                    
                    if (res.data.detail_score[0].content_count == 0)
                        this.progress.content = 100;
                    else
                        this.progress.content = Math.round(res.data.detail_score[0].content_passed * 100 / res.data.detail_score[0].content_count)
                    
                    if (res.data.detail_score[0].program_count == 0)
                        this.progress.programs = 100;
                    else
                        this.progress.programs = Math.round(res.data.detail_score[0].program_passed * 100 / res.data.detail_score[0].program_count)
                    
                    if (res.data.detail_score[0].task_count == 0)
                        this.progress.tasks = 100;
                    else
                        this.progress.tasks = Math.round(res.data.detail_score[0].task_passed * 100 / res.data.detail_score[0].task_count)

                    this.area_id = res.data.area.id
                    this.area_color = res.data.area.area_color

                    if (res.data.message != 'OK') {
                        this.$store.commit('setFeedback', res.data.message)
                    }
                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id }, //#
                    ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                    this.countProgress()
                    axios.get('/get-course-data/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                        .then((res) => {
                            this.dataCourse =  res.data.course
                            this.editPermissions = res.data.permissions
                            this.teacherPermissions = res.data.teacherPermissions
                            //console.log(res.data.permissions)
                        })
                        .catch(error => {
                            this.$store.commit('setFeedback', error)
                        })
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        resetCourse(t) {            
            this.$store.commit('setFeedback', null)    
            const data = { type: t }

            // get category list
            axios.post('/service-refresh-course/' + this.$route.params.id, data, this.$store.getters.getAxiosConfig)
                .then(() => {
                    // open course
                        this.$router.push({name:'courses', params: {id: this.area_id }})   
                    ///////////////////////////////////////////////////////////////////////
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },        
        continueCourse() {
            // open from last position by last task
        },
        getColor(index) {
            if (index == 0) return 'green'
            const c = this.content.chapter_list[index-1]           
            if ((c.programs_finished + c.tasks_finished) > (c.programs_nonfinished + c.tasks_nonfinished)) return 'green'
            return 'yellow'
        },
      countProgress() {
            // count progress
            var perc_t = 0
            var perc_p = 0
            var task_exists = 0
            var program_exists = 0
            var all_tasks = 0
            var all_programs
            var act = true
            this.describer = []

           // console.log(this.content.chapter_list)

            for(let i = 0; i < this.content.chapter_list.length; i++ ) {
                all_tasks = this.content.chapter_list[i].tasks_finished + this.content.chapter_list[i].tasks_nonfinished
                all_programs = this.content.chapter_list[i].programs_finished + this.content.chapter_list[i].programs_nonfinished
                task_exists = 0
                program_exists = 0
                if (all_tasks > 0) {
                    perc_t = Math.floor(0.5 + 100 * this.content.chapter_list[i].tasks_finished / all_tasks)
                    task_exists = 1
                }
                if (all_programs > 0) {
                    perc_p = Math.floor(0.5 + 100 * this.content.chapter_list[i].programs_finished / all_programs)
                    program_exists = 1                        
                }
                if (i > 0) {
                    let sum = this.describer[i-1].progress_tasks + this.describer[i-1].progress_programs
                    act = false
                    if (sum > 100) act = true
                    else if (sum > 50 && (!this.describer[i-1].tasks_exists || !this.describer[i-1].programs_exists)) act = true
                }
                this.describer.push({
                        progress_tasks : perc_t,
                        tasks_exists : task_exists,
                        progress_programs : perc_p,
                        programs_exists : program_exists,
                        active: act
                })                
            }
        },
        goToChapter(chapter) {
            this.$router.push({name:'chapter_content', params: {id: chapter.chapter_id}})   
        },
        showPractice() {
            this.content_type = 1
        },
        showCompetitions() {
            this.content_type = 2
            // read competitions and your result
            axios.get('/get-competitions/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.dataCompetition =  res.data
                    /* eslint-disable no-console */
                    //console.log(this.dataCompetition)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },

        startCompetition(index) {
            this.competition_index = index
            if (this.dataCompetition.opened[index].key) { // if is true
                this.$store.commit('setShowModalMessage',
                    {content: '"' + this.dataCompetition.opened[index].name + '" is a private competition. Type key.', type: 'warning', 
                        buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2}], input: 1})
            } else {
                this.$store.commit('setShowModalMessage',
                    {content: 'Do you want to start "' + this.dataCompetition.opened[index].name + '" competition?', type: 'warning', 
                        buttons:[], icons:[{text:'close', color:'red', value: 3},{text:'done', color:'green', value: 4}]})                
            }
        },
        processModalResult() {
            const res = this.getShowModalMessageResult
            this.$store.commit('setShowModalMessageResult',null)
            if (res == 2) {
                const my_key = this.$store.getters.getShowModalMessageText
                this.addCompetition(my_key)
            }
            if (res==4) this.addCompetition('')
        },
        addCompetition(my_key) {
            const data = { comp_id: this.dataCompetition.opened[this.competition_index].id,
                           comp_key: my_key, course_id : this.$route.params.id  }
            axios.post('/add-my-competition', data, this.$store.getters.getAxiosConfig)
                .then((res) => {                    
                    if (res.data.message == 'OK') {
                        this.$router.push({name:'competition_content', params: {id: res.data.user_comp_id }})   
                    } else {
                        this.$store.commit('setShowModalMessage',{content: res.data.description, type: 'info', 
                                            buttons:[{text:'OK', value: 1}], icons:[]})
                    }
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        openCompetition(index) {
            this.$router.push({name:'competition_content', params: {id: this.dataCompetition.joined[index].id }})   
        },
        getProgressColor(value) {
            if (value == 100) return "progress-color-1"
            return "progress-color-2"
        },        
        getCourseBackgroundColor(color) {
          return "background-color: "+color+";";
        },
        getNicerDateFormat(date) {
            if (date == '') return "N/A"
            const dateVar = new Date(date.replace(/\s/, 'T'));
            return (dateVar.getDate()+". "+("0"+(dateVar.getMonth()+1)).slice(-2)+". "+dateVar.getFullYear()+", "+dateVar.getHours()+":"+("0"+(dateVar.getMinutes())).slice(-2)); // getMonth()+1 - (January gives 0)
        },
        editCourse() {
            this.$router.push({name:'edit_chapters', params: {id: this.$route.params.id}})
        },
        editGroups() {
            this.$router.push({name:'teacher_groups', params: {id: this.$route.params.id}})
        },
        showQuizzes() {
            this.$router.push({name:'teacher_quizzes', params: {id: this.$route.params.id}})
        },
        studentSettings() {
            this.$router.push({name:'student_settings', params: {id: this.$route.params.id}})
        },
        showStudentDuels() {
            this.$router.push({name:'student_duels', params: {id: this.$route.params.id}})
        },
        showStudentQuizzes() {
            this.$router.push({name:'student_quizzes', params: {id: this.$route.params.id}})
        },
        showChapters(){
            this.$router.push({name:'teacher_chapters', params: {course_id: this.$route.params.id}})
        },
        showCourseTeachers() {
            this.$router.push({name:'course_teachers', params: {id: this.$route.params.id}})
        },
        showStudentRevisions() {
            this.$router.push({name:'revisions_student', params: {course_id: this.$route.params.id}})
        },
        showTeacherRevisions() {
            this.$router.push({name:'revisions_teacher', params: {id: this.$route.params.id}})
        },
        teacherCompetitions() {
            this.$router.push({name:'teacher_competitions', params: {course_id: this.$route.params.id}})
        }

    }
}
</script>


<style>
.access-icon {
  position: absolute;
  bottom: 1px;
  right: 1px;
  cursor: pointer;
}

</style>
